var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subscription-fqa-panel blue-block" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-container" },
      _vm._l(_vm.faqItems, function (item, idx) {
        return _c(
          "div",
          {
            key: idx,
            staticClass: "frequent-question-item flex-between-wrapper",
          },
          [
            _c("rt-picture", {
              staticClass: "icon-circle",
              attrs: { src: "/assets/app/class/icon-circle-yellow.svg" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "item-info-wrapper" }, [
              _c(
                "h3",
                {
                  staticClass: "question-info",
                  class: { expanded: item.expanded },
                  on: {
                    click: function ($event) {
                      return _vm.handleClickDropdown(idx)
                    },
                  },
                },
                [_vm._v(_vm._s(item.question))]
              ),
              _vm._v(" "),
              item.expanded
                ? _c("p", {
                    staticClass: "answer-info",
                    domProps: { innerHTML: _vm._s(item.answer) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "primary-button",
              {
                staticClass: "btn-expand-item btn-normal",
                on: {
                  click: function ($event) {
                    return _vm.handleClickDropdown(idx)
                  },
                },
              },
              [_c("rt-picture", { attrs: { src: _vm.itemButtonIcon(idx) } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-header" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v("Frequently asked questions"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }